<script setup>
const route = useRoute()
const mapName = 'okinawa'
if (route.path !== `/${mapName}/`) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid areaId'
  })
}
useCustomMeta('pref', getPrefectureName(mapName))
const breadCrumbList = getBreadCrumb(mapName)
const [golfGeoJson, golfNameList] = await Promise.all([
  useFetch('/api/map/geojson'),
  useFetch('/api/golf/list', { query: { areaName: mapName } })
]).then((responses) => responses.map((res) => res.data))
</script>

<template>
  <div>
    <NuxtLayout
      name="pref"
      :bread-crumb-list="breadCrumbList"
    >
      <div class="frame">
        <GolfMap
          :map-name="mapName"
          :latlon="prefLatlon[mapName]"
          :golf-json="golfGeoJson"
        />
      </div>
      <template #main-center>
        <GolfPointList
          :name-list="golfNameList"
          :pref-name="getPrefectureName(mapName)"
        />
        <GolfLog />
      </template>
      <template #main-bottom>
        <GolfRecommend area="okinawa" />
      </template>
    </NuxtLayout>
  </div>
</template>

<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
</style>
